import React from 'react';
import LazyLoad from 'react-lazyload';
import styled from 'styled-components';
import { media } from '../../utils/styles';
import { Heading2 } from '../common';

export const VideoSection = ({ heading, videoHtml }) => {
  return (
    <Section>
      <Container>
        <Heading>{heading}</Heading>
        <VideoWrapper once>
          <Video dangerouslySetInnerHTML={{ __html: videoHtml }} />
        </VideoWrapper>
      </Container>
    </Section>
  );
};

const VideoWrapper = styled(LazyLoad)`
  ${media.phone} {
    order: 1;
  }
`;

const Video = styled.div`
  > iframe {
    width: 100%;
    height: 436px;
    ${media.phone} {
      height: 248px;
    }
  }
`;

const Container = styled.div`
  width: 870px;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const Heading = styled(Heading2)`
  margin: 0 0 50px;
  ${media.phone} {
    margin: 36px 0 0;
    order: 2;
  }
`;

const Section = styled.section`
  padding: 80px 0 100px;
  ${media.phone} {
    padding: 0 0 60px;
  }
`;
